import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '/store/RootState';

import { ModuleUser } from './currentModule';

const selectCurrentModuleName = (state: RootState) => state.currentModule.moduleClass;
const selectOnlineUsers = (state: RootState) => state.currentModule.onlineUsers;

const selectModuleUsers = createSelector(
  selectCurrentModuleName,
  selectOnlineUsers,
  (currentModule, users): ModuleUser[] => {
    if (!currentModule) {
      return [];
    }

    return Object.values(users).filter((onlineUser) => onlineUser.module === currentModule);
  }
);

export const baseSelectors = {
  currentModule: (state: RootState) => state.currentModule,
  currentModuleName: selectCurrentModuleName,
  onlineUsers: selectOnlineUsers,
  isSpaceLessModule: (state: RootState) => state.currentModule.isSpaceLessModule,
};

export const currentModuleSelectors = {
  selectModuleUsers,
};
